import { QueryResult } from '@apollo/client/react'
import { Box, Center, Spinner } from '@chakra-ui/react'

type Props = {
  beforeRenderData?: (data: any) => any
  dataIsValid?: (data: any) => boolean
  query: QueryResult
  renderData?: (data: any) => any
  renderError?: (error: any) => any
  renderInvalidData?: (data: any) => any
  renderLoading?: (loading: boolean) => any
}

export const QueryContainer = (props: Props) => {
  if (props.query.data) {
    if (props.dataIsValid && !props.dataIsValid(props.query.data)) {
      if (props.renderInvalidData) {
        return props.renderInvalidData(props.query.data)
      }

      return (
        <Box padding={'12px'}>
          <Center>Error: data returned is invalid.</Center>
        </Box>
      )
    }

    if (props.beforeRenderData) {
      const beforeRenderData = props.beforeRenderData(props.query.data)
      if (beforeRenderData) {
        return beforeRenderData
      }
    }

    if (props.renderData) {
      return props.renderData(props.query.data)
    }

    return (
      <Box padding={'12px'}>
        <Center>Results Have Loaded. No renderData Provided.</Center>
      </Box>
    )
  }

  if (props.query.loading) {
    return props.renderLoading ? (
      props.renderLoading(props.query.loading)
    ) : (
      <Box padding={'12px'}>
        <Center>
          <Spinner />
        </Center>
      </Box>
    )
  }

  if (props.query.error) {
    return props.renderError ? (
      props.renderError(props.query.error)
    ) : (
      <Box padding={'12px'}>
        <Center>
          {'Error! '}
          {props.query.error.toString()}
        </Center>
      </Box>
    )
  }

  return (
    <Box padding={'1em'}>
      <Center>An error has occurred.</Center>
    </Box>
  )
}
